import React, { useState } from "react";
import { Modal, Button, Table, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";

const SelectStaffModal = ({ isVisible, onClose, onSelectEmployee }) => {
  const navigate = useNavigate();
  const orgId = localStorage.getItem("orgId") || 1;
  const branchId = localStorage.getItem("branchId") || 1;

  const [searchParams, setSearchParams] = useState({
    employeeName: "",
    employeeCode: "",
    department: "",
    designation: "",
  });
  const [employeeData, setEmployeeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleInputChange = (e) => {
    setSearchParams({ ...searchParams, [e.target.name]: e.target.value });
  };

  const handleSearch = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}Teacher/GetEmployeeList/?orgId=${orgId}&branchId=${branchId}`
      );
      const result = await response.json();
      if (result.message === "success") {
        let filteredData = result.data;
        if (searchParams.employeeName) {
          filteredData = filteredData.filter((emp) =>
            emp.employeeName
              .toLowerCase()
              .includes(searchParams.employeeName.toLowerCase())
          );
        }
        if (searchParams.employeeCode) {
          const requestedCode = searchParams.employeeCode.trim();
          filteredData = filteredData.filter((emp) =>
            String(emp.employee_code ?? "").trim() === requestedCode
          );
        }
        if (searchParams.department) {
          filteredData = filteredData.filter((emp) =>
            emp.departmentName
              .toLowerCase()
              .includes(searchParams.department.toLowerCase())
          );
        }
        if (searchParams.designation) {
          filteredData = filteredData.filter((emp) =>
            emp.designationName
              .toLowerCase()
              .includes(searchParams.designation.toLowerCase())
          );
        }
        setEmployeeData(filteredData);
        // handleClear();
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    setLoading(false);
  };

  const handleSelectEmployee = (employee) => {
    setSelectedEmployee(employee);
    if (onSelectEmployee) {
      onSelectEmployee(employee);
    }
    onClose();
  };

  const handleClear = () => {
    setSearchParams({
      employeeName: "",
      employeeCode: "",
      department: "",
      designation: "",
    });
    setEmployeeData([]);
  };

  const handleNew = () => {
    navigate("/AdmStaffDetails");
  };

  return (
    <Modal
      show={isVisible}
      onHide={onClose}
      size="xl"
      centered
      backdrop={"static"}
    >
      <Modal.Header closeButton>
        {/* <Modal.Title>Employee Search</Modal.Title> */}
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          {/* <div className="row mb-3">
            <div className="col-12 d-flex justify-content-start">
              <Button className="me-2" onClick={handleNew}>New</Button>
              <Button className="me-2" onClick={handleSearch} disabled={loading}>
                {loading ? "Searching..." : "Search"}
              </Button>
              <Button className="me-2" onClick={handleClear}>Clear</Button>
              <Button onClick={onClose}>Close</Button>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-3">
              <Form.Label>Teacher Name</Form.Label>
              <Form.Control
                type="text"
                name="employeeName"
                value={searchParams.employeeName}
                onChange={handleInputChange}
                placeholder="Enter employee name"
              />
            </div>
            <div className="col-md-3">
              <Form.Label>Teacher Code</Form.Label>
              <Form.Control
                type="text"
                name="employeeCode"
                value={searchParams.employeeCode}
                onChange={handleInputChange}
                placeholder="Enter employee code"
              />
            </div>
            <div className="col-md-3">
              <Form.Label>Department</Form.Label>
              <Form.Control
                type="text"
                name="department"
                value={searchParams.department}
                onChange={handleInputChange}
                placeholder="Enter department"
              />
            </div>
            <div className="col-md-3">
              <Form.Label>Designation</Form.Label>
              <Form.Control
                type="text"
                name="designation"
                value={searchParams.designation}
                onChange={handleInputChange}
                placeholder="Enter designation"
              />
            </div>
          </div>

          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Teacher Name</th>
                  <th>Teacher Code</th>
                  <th>Department</th>
                  <th>Designation</th>
                </tr>
              </thead>
              <tbody>
                {employeeData.length > 0 ? (
                  employeeData.map((employee) => (
                    <tr key={employee.id}>
                      <td>{employee.employeeName}</td>
                      <td>{employee.employee_code}</td>
                      <td>{employee.departmentName}</td>
                      <td>{employee.designationName}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div> */}

          <div className="row">
            <div className="col-12">
              <div className="card p-0">
                <div className="card-body">
                  <p
                    style={{
                      marginBottom: "0px",
                      textAlign: "center",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    EMPLOYEE SEARCH
                  </p>
                  <div className="row mb-3 mt-3">
                    <div
                      className="col-12 d-flex flex-wrap gap-2"
                      // style={{ border: "1px solid #ccc" }}
                    >
                      {/* <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{
                          "--bs-btn-padding-y": ".25rem",
                          "--bs-btn-padding-x": ".5rem",
                          "--bs-btn-font-size": ".75rem",
                          width: "150px",
                        }}
                        onClick={handleNew}
                      >
                        New
                      </button> */}
                      <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{
                          width: "150px",
                        }}
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      {/* <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSearch}
                        disabled={loading}
                      >
                        {loading ? "Searching..." : "Search"}
                      </button> */}
                      <button
                        type="button"
                        className="btn btn-secondary me-2"
                        style={{
                          width: "150px",
                        }}
                        onClick={handleClear}
                      >
                        Clear
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger me-2"
                        style={{
                          width: "150px",
                        }}
                        onClick={onClose}
                      >
                        Close
                      </button>
                    </div>
                  </div>

                  {/* Search Fields */}
                  <div className="row justify-content-center p-2">
                    <div
                      className="col-12"
                      style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                    >
                      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                        <div className="row flex-grow-1">
                          <div className="col-12 col-md-3 mb-0">
                            <label
                              htmlFor="employee-code"
                              className="form-label"
                            >
                              Teacher Name
                            </label>
                            <div className="d-flex align-items-center">
                              <input
                                type="text"
                                name="employeeName"
                                value={searchParams.employeeName}
                                onChange={handleInputChange}
                                placeholder="Enter employee name"
                              />
                            </div>
                          </div>
                          <div className="col-12 col-md-3 mb-0">
                            <label
                              htmlFor="student-name"
                              className="form-label"
                            >
                              Teacher Code
                            </label>
                            <div className="d-flex align-items-center">
                              <input
                                type="text"
                                name="employeeCode"
                                value={searchParams.employeeCode}
                                onChange={handleInputChange}
                                placeholder="Enter employee code"
                              />
                            </div>
                          </div>
                          <div className="col-12 col-md-3 mb-0">
                            {/* <label
                              htmlFor="employee-type"
                              className="form-label"
                            >
                              Department
                            </label>
                            <select
                              id="employee-type"
                              // className="form-select"
                              name="department"
                              value={searchParams.department}
                              onChange={handleInputChange}
                              placeholder="Enter department"
                            > */}
                              {/* <option value="">Select employee type</option>
                              <option value="admin">Admin</option>
                              <option value="teacher">Teacher</option>
                            </select> */}
                          </div>
                          <div className="col-12 col-md-3 mb-0">
                            {/* <label
                              htmlFor="employee-type"
                              className="form-label"
                            >
                              Designation
                            </label> */}
                            {/* <select
                              id="employee-type"
                              // className="form-select"
                              name="designation"
                              value={searchParams.designation}
                              onChange={handleInputChange}
                              placeholder="Enter designation"
                            >
                              <option value="">Select employee type</option>
                              <option value="admin">Admin</option>
                              <option value="teacher">Teacher</option>
                            </select> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Students Table */}
                  <div className="row">
                    <div className="col-12">
                      <div className="table-responsive">
                        <table className="table table-bordered ">
                          <thead>
                            <tr>
                              {/* <th>Sr.No</th> */}
                              <th>Teacher Name</th>
                              <th>Teacher Code</th>
                              <th>Department</th>
                              <th>Designation</th>
                              <th>Select</th>
                            </tr>
                          </thead>
                          <tbody>
                            {employeeData.length > 0 ? (
                              employeeData.map((employee, index) => (
                                <tr key={employee.id}>
                                  <td>{employee.employeeName}</td>
                                  <td>{employee.employee_code}</td>
                                  <td>{employee.departmentName}</td>
                                  <td>{employee.designationName}</td>
                                  <td>
                                    <input
                                      type="radio"
                                      name="selectedEmployee"
                                      // checked={selectedStudent === student}
                                      onChange={() =>
                                        handleSelectEmployee(employee)
                                      }
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="4" className="text-center">
                                  No Data Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SelectStaffModal;
